/* Season gate – Kamerafahrt zu Beginn, Parallax, Gebetsfahnen, Partikel */
(function () {
  var gate = document.querySelector('.season-gate--scene');
  if (!gate) return;

  var scene = gate.querySelector('[data-sg-scene]');
  var sign = gate.querySelector('.sg-sign');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(location.search);
  var freeze = params.has('sg-freeze') ? parseFloat(params.get('sg-freeze')) || 0 : null;
  var posted = /customer_posted=true/.test(location.search) || /^#season-gate/.test(location.hash) || !!gate.querySelector('.sg-board .banner');

  var layers = Array.prototype.map.call(gate.querySelectorAll('[data-depth]'), function (el) {
    var z = parseFloat(el.getAttribute('data-z'));
    // mz: Startvergrößerung der Handy-Fahrt, nahe Ebenen stärker (Tiefenwirkung ohne sichtbare Bildkanten)
    return { el: el, depth: parseFloat(el.getAttribute('data-depth')) || 0, z: isNaN(z) ? null : z, mz: isNaN(z) ? 1 : 1.08 + 0.44 / (1 + z / 4), ox: 0, oy: 0 };
  });

  /* ---------- Kamerafahrt: vom Gipfel rückwärts durchs Tal ----------
     Jede Ebene hat eine Entfernung z. Die Kamera startet bei c0 nahe am Berg und fährt bis 0 zurück.
     Maßstab einer Ebene = z / (z - c). Ebenen hinter der Kamera (z <= c) sind unsichtbar und
     „fliegen“ von hinten ins Bild, sobald die Kamera an ihnen vorbeigezogen ist. */
  var hasCamera = layers.some(function (L) { return L.z !== null; });
  var vpLayer = gate.querySelector('[data-vp]');
  var START_ZOOM = window.innerWidth < 741 ? 2.1 : 1.9;
  var SMAX = 4.2;
  /* Hochformat (Handy): Hier ist die gemalte Welt im Verhältnis zum Bildschirm niedriger. Würden Ebenen „hinter
     der Kamera“ warten, sähe man die Unterkanten der hinteren Bilder. Stattdessen „Durch die Wolken“: Nebel und
     Wolken geben die Szene von oben nach unten frei, die Kamera fährt dabei etwas zurück. Alle Ebenen bleiben
     sichtbar und überlappen sich immer, nahe Ebenen sind anfangs etwas stärker vergrößert (Tiefenwirkung). */
  var MOBILE = window.matchMedia('(orientation: portrait)').matches || window.innerWidth < 741;
  var veilAnims = [];
  var camera = { c0: 0, duration: MOBILE ? 4200 : 4600, start: null, done: !hasCamera, skipAt: null, xAtSkip: 0 };
  var signShown = false;

  function measureOrigins() {
    if (!hasCamera || !vpLayer) return;
    layers.forEach(function (L) { L.el.style.transform = 'none'; });
    var vr = vpLayer.getBoundingClientRect();
    var vp = (vpLayer.getAttribute('data-vp') || '0.5,0.2').split(',').map(parseFloat);
    var vx = vr.left + vr.width * vp[0];
    var vy = vr.top + vr.height * vp[1];
    // Handy: die Kamera zieht sich von oben mittig zurück, so steigen Hügel und Wiese von unten ins Bild
    if (MOBILE) { vx = window.innerWidth / 2; vy = window.innerHeight * 0.22; }
    layers.forEach(function (L) {
      var r = L.el.getBoundingClientRect();
      L.ox = vx - r.left;
      L.oy = vy - r.top;
      L.el.style.transformOrigin = L.ox.toFixed(1) + 'px ' + L.oy.toFixed(1) + 'px';
    });
    var zp = parseFloat(vpLayer.getAttribute('data-z')) || 12;
    camera.c0 = zp * (1 - 1 / START_ZOOM);
    measureFlight();
  }

  /* ---------- Kamerafahrt auf einer Leinwand (Chrome am Computer) ----------
     Chrome zerlegt die stark vergrößerten Ebenen in Kacheln. Reicht der Grafikspeicher nicht, fehlen mitten
     in der Fahrt Kacheln und Berge, Wiese und Büsche flackern. Darum zeichnet das Skript die Welt während
     der Fahrt selbst auf eine Leinwand: dieselben Bilder an denselben Stellen, gerechnet wie die Ebenen.
     Die echten Ebenen stehen derweil fast unsichtbar in Ruhelage (.sg-cflying im CSS). Am Ende der Fahrt
     übernehmen sie wieder und die Leinwand blendet aus. */
  var cfLayers = layers.filter(function (L) {
    return L.z !== null && !!(L.el.closest('.sg-world') || L.el.classList.contains('sg-bush'));
  });
  var CFLIGHT = !MOBILE && cfLayers.length > 0 && /Chrome\/\d+/.test(navigator.userAgent) &&
    gate.classList.contains('season-gate--classic');
  var cf = null;

  // Misst jedes Bild und jeden Nebel einer Ebene in Ruhelage (alle Ebenen stehen gerade ohne Transform)
  function measureFlight() {
    if (!CFLIGHT) return;
    var sr = scene.getBoundingClientRect();
    cfLayers.forEach(function (L) {
      var r = L.el.getBoundingClientRect();
      L.rx = r.left - sr.left;
      L.ry = r.top - sr.top;
      L.items = [];
      Array.prototype.forEach.call(L.el.querySelectorAll('img, .sg-mist'), function (el) {
        var op = 1;
        for (var n = el; n && n !== L.el; n = n.parentElement) op *= parseFloat(getComputedStyle(n).opacity);
        if (!(op > 0.001)) return;
        var b = el.getBoundingClientRect();
        if (!b.width || !b.height) return;
        var cs = getComputedStyle(el);
        var it = { el: el, x: b.left - r.left, y: b.top - r.top, w: b.width, h: b.height, op: op,
          filter: cs.filter && cs.filter !== 'none' ? cs.filter : null };
        if (el.tagName !== 'IMG') {
          // Nebel: elliptischer Verlauf wie im CSS (radial-gradient ellipse at center, border-radius 50 %)
          var stops = [];
          var re = /(rgba?\([^)]*\))\s*([\d.]+)%/g;
          var m;
          while ((m = re.exec(cs.backgroundImage))) stops.push([Math.min(1, parseFloat(m[2]) / 100), m[1]]);
          if (!stops.length) return;
          it.stops = stops;
        }
        L.items.push(it);
      });
      L.fx = { x: 0, y: 0, s: 1, o: 1 };
    });
  }

  function sizeFlight() {
    if (!cf) return;
    cf.dpr = Math.min(window.devicePixelRatio || 1, 2);
    cf.w = scene.clientWidth;
    cf.h = scene.clientHeight;
    [cf.cv, cf.off].forEach(function (c) {
      c.width = Math.round(cf.w * cf.dpr);
      c.height = Math.round(cf.h * cf.dpr);
    });
  }

  function setupFlight() {
    if (!CFLIGHT || cf) return;
    var cv = document.createElement('canvas');
    var off = document.createElement('canvas');
    var ctx = cv.getContext && cv.getContext('2d');
    var octx = off.getContext && off.getContext('2d');
    if (!ctx || !octx || !('filter' in ctx)) return;
    cv.className = 'sg-cflight';
    cv.setAttribute('aria-hidden', 'true');
    scene.insertBefore(cv, scene.querySelector('.sg-particles'));
    cf = { cv: cv, ctx: ctx, off: off, octx: octx, ending: false };
    sizeFlight();
    measureFlight();
    cfLayers.forEach(function (L) { L.cf = true; });
    gate.classList.add('sg-cflying');
  }

  function endFlight() {
    if (!cf || cf.ending) return;
    cf.ending = true;
    gate.classList.remove('sg-cflying');
    cf.cv.classList.add('is-out');
    setTimeout(function () {
      if (!cf) return;
      if (cf.cv.parentNode) cf.cv.parentNode.removeChild(cf.cv);
      cfLayers.forEach(function (L) { L.cf = false; });
      cf = null;
    }, 600);
  }

  function drawFlightItems(ctx, L, f, alpha) {
    // Gleiche Rechnung wie transform: translate3d(x, y, 0) scale(s) mit Ursprung (ox, oy)
    var bx = L.rx + L.ox + f.x - f.s * L.ox;
    var by = L.ry + L.oy + f.y - f.s * L.oy;
    for (var k = 0; k < L.items.length; k++) {
      var it = L.items[k];
      var dx = bx + f.s * it.x;
      var dy = by + f.s * it.y;
      var dw = f.s * it.w;
      var dh = f.s * it.h;
      if (dx > cf.w || dy > cf.h || dx + dw < 0 || dy + dh < 0) continue;
      ctx.globalAlpha = alpha * it.op;
      if (it.stops) {
        ctx.save();
        ctx.translate(dx + dw / 2, dy + dh / 2);
        ctx.scale(dw / 2, dh / 2);
        var g = ctx.createRadialGradient(0, 0, 0, 0, 0, Math.SQRT2);
        for (var q = 0; q < it.stops.length; q++) g.addColorStop(it.stops[q][0], it.stops[q][1]);
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(0, 0, 1, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      } else {
        // Schatten der Ziegen wachsen mit der Ebene (Längen im Filter folgen der Leinwand-Skalierung)
        ctx.filter = it.filter ? it.filter.replace(/(-?[\d.]+)px/g, function (all, v) { return (v * f.s).toFixed(2) + 'px'; }) : 'none';
        ctx.drawImage(it.el, dx, dy, dw, dh);
        ctx.filter = 'none';
      }
    }
  }

  function drawFlight() {
    var ctx = cf.ctx;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, cf.cv.width, cf.cv.height);
    ctx.setTransform(cf.dpr, 0, 0, cf.dpr, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    for (var i = 0; i < cfLayers.length; i++) {
      var L = cfLayers[i];
      var f = L.fx;
      if (!L.items || !L.items.length || f.o <= 0.002) continue;
      if (f.o < 0.999 && L.items.length > 1) {
        // Halbtransparente Ebene mit mehreren Bildern (Ziegen auf der Wiese): erst einzeln zeichnen, dann
        // als Ganzes abblenden, wie Chrome die Ebene abblendet
        var o = cf.octx;
        o.setTransform(1, 0, 0, 1, 0, 0);
        o.clearRect(0, 0, cf.off.width, cf.off.height);
        o.setTransform(cf.dpr, 0, 0, cf.dpr, 0, 0);
        o.imageSmoothingEnabled = true;
        o.imageSmoothingQuality = 'high';
        drawFlightItems(o, L, f, 1);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.globalAlpha = f.o;
        ctx.drawImage(cf.off, 0, 0);
        ctx.setTransform(cf.dpr, 0, 0, cf.dpr, 0, 0);
      } else {
        drawFlightItems(ctx, L, f, f.o);
      }
    }
    ctx.globalAlpha = 1;
  }

  function easeInOutCubic(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }

  function cameraAt(e) {
    // Logarithmische Fahrt: jede Ebene bekommt ungefähr gleich viel Zeit zum Hereinfliegen
    return Math.pow(camera.c0 + 1, 1 - e) - 1;
  }

  function showSign() {
    if (signShown) return;
    signShown = true;
    gate.classList.add('sg-sign-in');
    setTimeout(function () { gate.classList.add('sg-intro-done'); }, 2400);
  }

  // Wer nicht warten will: Klick, Tippen, Scrollen oder Taste beschleunigt die Fahrt zum Ende
  function skipIntro() {
    if (camera.done || camera.start === null || camera.skipAt !== null) return;
    camera.skipAt = performance.now();
    camera.xAtSkip = Math.min(1, (camera.skipAt - camera.start) / camera.duration);
    veilAnims.forEach(function (a) { try { a.playbackRate = 4; } catch (err) { /* egal */ } });
  }

  // Handy-Eröffnung: Nebel in der Farbe der Tageszeit lichtet sich von oben, gemalte Wolken ziehen zur Seite davon
  function playVeil(ms, keep) {
    if (!Element.prototype.animate) return;
    var srcs = Array.prototype.map.call(scene.querySelectorAll('img.sg-cloud'), function (im) { return im.currentSrc || im.src; }).filter(Boolean);
    var veil = document.createElement('div');
    veil.className = 'sg-veil';
    var mist = document.createElement('div');
    mist.className = 'sg-veil__mist';
    veil.appendChild(mist);
    veilAnims.push(mist.animate([
      { transform: 'translate3d(0,0,0)', opacity: 1 },
      { transform: 'translate3d(0,62%,0)', opacity: 0 }
    ], { duration: ms * 0.6, delay: ms * 0.06, easing: 'cubic-bezier(0.4, 0, 0.3, 1)', fill: 'both' }));
    // oben zuerst: die oberen Wolken ziehen früher ab als die unteren
    [
      { l: -34, t: -6, w: 120, dx: -72, dy: -8 },
      { l: 20, t: 8, w: 126, dx: 74, dy: -6 },
      { l: -42, t: 27, w: 136, dx: -78, dy: -4 },
      { l: 16, t: 45, w: 132, dx: 78, dy: -2 },
      { l: -32, t: 63, w: 140, dx: -74, dy: 0 },
      { l: 8, t: 80, w: 132, dx: 72, dy: 2 }
    ].forEach(function (p, i) {
      if (!srcs.length) return;
      var im = document.createElement('img');
      im.className = 'sg-veil__cloud';
      im.alt = '';
      im.src = srcs[i % srcs.length];
      im.style.left = p.l + 'vw';
      im.style.top = p.t + 'vh';
      im.style.width = p.w + 'vw';
      veil.appendChild(im);
      veilAnims.push(im.animate([
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
        { transform: 'translate3d(' + p.dx + 'vw,' + p.dy + 'vh,0) scale(1.6)', opacity: 0 }
      ], { duration: ms * 0.55, delay: ms * (0.1 + i * 0.07), easing: 'cubic-bezier(0.45, 0, 0.3, 1)', fill: 'both' }));
    });
    scene.insertBefore(veil, scene.querySelector('.sg-particles'));
    if (!keep) setTimeout(function () { if (veil.parentNode) veil.parentNode.removeChild(veil); veilAnims = []; }, ms * 1.1 + 300);
  }

  ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (type) {
    gate.addEventListener(type, skipIntro, { passive: true });
  });

  function startIntro() {
    scene.classList.remove('sg-scene--loading');
    var skip = reduceMotion || posted || !hasCamera || gate.classList.contains('sg-fallback') || gate.classList.contains('sg-editor');
    if (freeze !== null) {
      camera.start = -1;
      gate.classList.add('sg-go');
      // Standbild zum Prüfen (?sg-freeze=0..1): auf dem Handy auch den Wolkenschleier an dieser Stelle anhalten
      if (MOBILE) {
        playVeil(camera.duration, true);
        veilAnims.forEach(function (a) { a.pause(); a.currentTime = freeze * camera.duration; });
      }
      if (freeze >= 0.82) showSign();
      return;
    }
    if (skip) {
      camera.done = true;
      gate.classList.remove('sg-flying');
      endFlight();
      gate.classList.add('sg-go');
      layers.forEach(function (L) { L.el.style.opacity = ''; });
      showSign();
      return;
    }
    // Während der Fahrt stehen Animationen in den fliegenden Ebenen still (siehe .sg-flying im CSS)
    gate.classList.add('sg-flying');
    camera.start = performance.now();
    if (MOBILE) playVeil(camera.duration);
    // erst jetzt wird die Szene sichtbar, das CSS blendet sie ein
    gate.classList.add('sg-go');
  }

  function willFly() {
    return hasCamera && !reduceMotion && !posted && freeze === null &&
      !gate.classList.contains('sg-fallback') && !gate.classList.contains('sg-editor');
  }

  /* ---------- Gebetsfahnen am Pfahl ---------- */
  var FLAG_COLORS = (scene.getAttribute('data-flag-colors') || '#5f84ad,#f5efe2,#c65b4c,#6f9b6c,#e3b94f').split(',');
  var PETAL_COLORS = (scene.getAttribute('data-petal-colors') || '255,182,193|242,150,160|250,210,215').split('|');
  var svgNS = 'http://www.w3.org/2000/svg';
  var flagsSvg = gate.querySelector('.sg-flags');

  function drawFlags() {
    if (!flagsSvg || !sign) return;
    flagData = [];
    var top = gate.querySelector('.sg-post__top');
    var vw = document.documentElement.clientWidth;
    var signRect = sign.getBoundingClientRect();
    var topRect = top.getBoundingClientRect();
    var anchorY = topRect.top - signRect.top + topRect.height * 0.35;
    var reach = vw / 2 + 60;
    var width = reach * 2;
    var height = Math.max(260, anchorY + 260);

    flagsSvg.setAttribute('viewBox', (-reach) + ' 0 ' + width + ' ' + height);
    flagsSvg.setAttribute('width', width);
    flagsSvg.setAttribute('height', height);
    flagsSvg.style.marginLeft = (-reach) + 'px';
    while (flagsSvg.firstChild) flagsSvg.removeChild(flagsSvg.firstChild);

    var small = vw < 741;
    var flagW = small ? 11 : 15;
    var flagH = small ? 14 : 19;
    var gap = small ? 7 : 9;
    var drop = small ? 70 : 120;
    var sag = small ? 26 : 46;

    [-1, 1].forEach(function (dir) {
      var x0 = dir * 6;
      var x1 = dir * reach;
      var y0 = anchorY;
      var y1 = anchorY + drop;
      var pts = [];
      var steps = 60;
      for (var i = 0; i <= steps; i++) {
        var u = i / steps;
        pts.push([x0 + (x1 - x0) * u, y0 + (y1 - y0) * Math.pow(u, 1.25) + sag * Math.sin(Math.PI * u)]);
      }
      var len = 0;
      var seg = [];
      for (var j = 1; j < pts.length; j++) {
        var d = Math.hypot(pts[j][0] - pts[j - 1][0], pts[j][1] - pts[j - 1][1]);
        seg.push(d);
        len += d;
      }

      // Laterne (nur nachts sichtbar) hängt links neben der Tafel an der Schnur
      var lantern = gate.querySelector('.sg-lantern');
      if (dir < 0 && lantern) {
        var board = gate.querySelector('.sg-board');
        var lx = -Math.min((board ? board.offsetWidth / 2 : 200) + 58, vw / 2 - 26);
        for (var li = 1; li < pts.length; li++) {
          if (pts[li][0] <= lx) {
            lantern.style.setProperty('--lx', (signRect.width / 2 + lx).toFixed(1) + 'px');
            lantern.style.setProperty('--ly', (pts[li][1] - 3).toFixed(1) + 'px');
            break;
          }
        }
      }

      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute('class', 'sg-string');
      path.setAttribute('d', 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' L'));
      path.style.setProperty('--len', Math.ceil(len));
      flagsSvg.appendChild(path);

      var count = Math.floor((len - 30) / (flagW + gap));
      for (var n = 0; n < count; n++) {
        var target = 26 + n * (flagW + gap);
        var acc = 0;
        var k = 0;
        while (k < seg.length - 1 && acc + seg[k] < target) { acc += seg[k]; k++; }
        var t = (target - acc) / seg[k];
        var px = pts[k][0] + (pts[k + 1][0] - pts[k][0]) * t;
        var py = pts[k][1] + (pts[k + 1][1] - pts[k][1]) * t;
        var ang = Math.atan2(pts[k + 1][1] - pts[k][1], pts[k + 1][0] - pts[k][0]) * 180 / Math.PI;
        if (dir < 0) ang += 180;

        var g = document.createElementNS(svgNS, 'g');
        g.setAttribute('transform', 'translate(' + px.toFixed(1) + ' ' + py.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
        var flag = document.createElementNS(svgNS, 'path');
        var w = flagW;
        var h = flagH * (0.92 + Math.random() * 0.16);
        flag.setAttribute('d', 'M' + (-w / 2) + ' 0 L' + (w / 2) + ' 0 L' + (w / 2 - 0.6) + ' ' + h + ' Q0 ' + (h + 1.8) + ' ' + (-w / 2 + 0.6) + ' ' + h + ' Z');
        flag.setAttribute('fill', FLAG_COLORS[n % FLAG_COLORS.length]);
        flag.setAttribute('fill-opacity', '0.92');
        flag.setAttribute('class', 'sg-flag');
        flag.style.setProperty('--d', (2 + Math.random() * 1.2).toFixed(2) + 's');
        flag.style.setProperty('--a', ((Math.random() > 0.5 ? 1 : -1) * (5 + Math.random() * 6)).toFixed(1) + 'deg');
        flag.style.setProperty('--ph', (-n * 0.17 - Math.random()).toFixed(2) + 's');
        flag.style.setProperty('--i', n);
        g.appendChild(flag);
        flagsSvg.appendChild(g);
        // für die Easter Eggs: Mitte der Fahne in Pixeln ab der linken oberen Ecke des SVG
        flagData.push({ g: g, base: g.getAttribute('transform'), sx: px + reach, sy: py + h * 0.5, i: flagData.length, c: FLAG_COLORS[n % FLAG_COLORS.length].trim(), a: 0, v: 0, moved: false });
      }
    });
    flagsSvg.classList.add('is-drawn');
  }

  /* ---------- Schmetterlinge (nur Variante „bunt“) ---------- */
  var butterflies = Array.prototype.map.call(scene.querySelectorAll('.sg-butterfly'), function (el) {
    return {
      el: el,
      ax: 0.1 + Math.random() * 0.08,
      ay: 0.06 + Math.random() * 0.05,
      f1: 0.11 + Math.random() * 0.08,
      f2: 0.23 + Math.random() * 0.1,
      p1: Math.random() * 6.28,
      p2: Math.random() * 6.28,
      cx: parseFloat(el.getAttribute('data-x')),
      cy: parseFloat(el.getAttribute('data-y')),
      lx: 0,
      ly: 0,
      x: 0,
      y: 0,
      mode: 'wander',
      dir: 1,
      sc: 1,
      ref: scene.querySelector('.sg-vignette')
    };
  });

  /* ---------- Partikel: Sterne, Staub, Blütenblätter, Blätter, Glitzern ---------- */
  var MODE = scene.getAttribute('data-particles') || 'classic';
  var DAWN = MODE === 'dawn';
  var WALD = MODE === 'waldmueller';
  var NIGHT = MODE === 'night';
  var FLUFF = NIGHT ? '225,232,248' : '255,251,242';
  var glintEl = scene.querySelector('[data-glint]');
  var glintRects = glintEl ? glintEl.getAttribute('data-glint').split(';').map(function (r) {
    return r.split(',').map(parseFloat);
  }) : [];
  var glintBox = null;
  var canvas = scene.querySelector('.sg-particles');
  var ctx = canvas && canvas.getContext('2d');
  var particles = [];
  var cw = 0;
  var ch = 0;
  var dpr = 1;

  function sizeCanvas() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    cw = canvas.clientWidth;
    ch = canvas.clientHeight;
    canvas.width = Math.round(cw * dpr);
    canvas.height = Math.round(ch * dpr);
    var petals = Math.round(Math.min(28, (cw * ch) / 48000));
    var pollen = Math.round(Math.min(40, (cw * ch) / 30000));
    particles = [];
    if (WALD) {
      var leaves = Math.round(Math.min(12, (cw * ch) / 110000));
      for (var l = 0; l < leaves; l++) particles.push(makeLeaf(true));
      if (glintRects.length) for (var g = 0; g < 46; g++) particles.push(makeGlint());
      for (var m = 0; m < Math.round(pollen * 0.35); m++) particles.push(makePollen());
      return;
    }
    if (DAWN) {
      var stars = Math.round(Math.min(90, (cw * ch) / 14000));
      for (var s = 0; s < stars; s++) particles.push(makeStar());
      for (var d = 0; d < Math.round(pollen * 0.8); d++) particles.push(makePollen());
      return;
    }
    // Tageszeiten der bunten Wiese
    if (NIGHT) {
      var nstars = Math.round(Math.min(46, (cw * ch) / 26000));
      for (var ns = 0; ns < nstars; ns++) particles.push(makeStar(0.22, 2.2));
      var flies = Math.round(Math.min(24, (cw * ch) / 52000));
      for (var nf = 0; nf < flies; nf++) particles.push(makeFirefly());
      return;
    }
    if (MODE === 'morning') {
      for (var mp = 0; mp < Math.round(petals * 0.5); mp++) particles.push(makePetal(true));
      for (var mq = 0; mq < Math.round(pollen * 0.6); mq++) particles.push(makePollen());
      for (var md = 0; md < Math.round(Math.min(34, (cw * ch) / 34000)); md++) particles.push(makeDew());
      return;
    }
    if (MODE === 'evening') {
      for (var ep = 0; ep < Math.round(petals * 0.6); ep++) particles.push(makePetal(true));
      for (var eq = 0; eq < Math.round(pollen * 1.5); eq++) { var gp = makePollen(); gp.gold = true; particles.push(gp); }
      return;
    }
    for (var i = 0; i < petals; i++) particles.push(makePetal(true));
    for (var j = 0; j < pollen; j++) particles.push(makePollen());
  }

  function makePetal(anywhere) {
    return {
      type: 'petal',
      x: anywhere ? Math.random() * cw : -20 - Math.random() * 80,
      y: anywhere ? Math.random() * ch : Math.random() * ch * 0.8,
      s: 4 + Math.random() * 5,
      vx: 0.25 + Math.random() * 0.5,
      vy: 0.12 + Math.random() * 0.35,
      r: Math.random() * 6.28,
      vr: (Math.random() - 0.5) * 0.04,
      ph: Math.random() * 6.28,
      z: 0.5 + Math.random() * 0.8,
      c: PETAL_COLORS[Math.floor(Math.random() * PETAL_COLORS.length)]
    };
  }

  function makeLeaf(anywhere) {
    var greens = ['96,122,48', '128,146,60', '168,158,72', '146,108,52', '84,104,40'];
    var fromLeft = Math.random() < 0.6;
    return {
      type: 'leaf',
      x: fromLeft ? Math.random() * cw * 0.42 : cw * (0.68 + Math.random() * 0.32),
      y: anywhere ? Math.random() * ch : -20 - Math.random() * 120,
      s: 5 + Math.random() * 4,
      vx: (Math.random() - 0.35) * 0.4,
      vy: 0.35 + Math.random() * 0.45,
      r: Math.random() * 6.28,
      vr: (Math.random() - 0.5) * 0.05,
      ph: Math.random() * 6.28,
      z: 0.6 + Math.random() * 0.6,
      c: greens[Math.floor(Math.random() * greens.length)]
    };
  }

  function makeGlint() {
    var r = glintRects[Math.floor(Math.random() * glintRects.length)];
    return {
      type: 'glint',
      u: (r[0] + Math.random() * (r[2] - r[0])) / 100,
      v: (r[1] + Math.random() * (r[3] - r[1])) / 100,
      ph: Math.random() * 6.28,
      sp: 0.002 + Math.random() * 0.004,
      s: 1 + Math.random() * 1.6
    };
  }

  function makeStar(frac, pw) {
    var top = ch * (frac || 0.34);
    var y = Math.pow(Math.random(), pw || 1.6) * top;
    return {
      type: 'star',
      x: Math.random() * cw,
      y: y,
      s: 0.5 + Math.random() * 1.1,
      ph: Math.random() * 6.28,
      sp: 0.0006 + Math.random() * 0.0016,
      a: 0.35 + Math.random() * 0.55 * (1 - y / top),
      z: 0.05
    };
  }

  // Glühwürmchen: wandern langsam über Wiese und Hügel und glimmen auf
  function makeFirefly() {
    return {
      type: 'firefly',
      x: Math.random() * cw,
      y: ch * (0.5 + Math.random() * 0.45),
      a: Math.random() * 6.283,
      v: 0.15 + Math.random() * 0.25,
      ph: Math.random() * 6.283,
      sp: 0.0009 + Math.random() * 0.0014,
      s: 1.3 + Math.random() * 1.1,
      z: 0.5 + Math.random() * 0.6
    };
  }

  // Tautropfen, die im Morgenlicht auf der Wiese aufblitzen
  function makeDew() {
    return {
      type: 'dew',
      x: Math.random() * cw,
      y: ch * (0.7 + Math.random() * 0.28),
      ph: Math.random() * 6.283,
      sp: 0.0012 + Math.random() * 0.002,
      s: 1.6 + Math.random() * 2,
      z: 0.9
    };
  }

  // Sternschnuppe: alle 10 bis 20 Sekunden eine, nur hoch am Himmel
  var shoot = null;
  var nextShoot = 0;

  function drawShootingStar(t) {
    if (!shoot) {
      if (!nextShoot) nextShoot = t + 4000 + Math.random() * 5000;
      if (t < nextShoot) return;
      var dir = Math.random() < 0.5 ? -1 : 1;
      shoot = { x: cw * (0.15 + Math.random() * 0.7), y: ch * (0.02 + Math.random() * 0.07), vx: dir * (8 + Math.random() * 5), vy: 1 + Math.random() * 0.8, t0: t, life: 650 + Math.random() * 300, len: 80 + Math.random() * 70 };
      nextShoot = t + 10000 + Math.random() * 10000;
    }
    var k = (t - shoot.t0) / shoot.life;
    if (k >= 1) { shoot = null; return; }
    shoot.x += shoot.vx;
    shoot.y += shoot.vy;
    var n = Math.hypot(shoot.vx, shoot.vy);
    var tx = shoot.x - shoot.vx / n * shoot.len;
    var ty = shoot.y - shoot.vy / n * shoot.len;
    var a = k < 0.15 ? k / 0.15 : 1 - (k - 0.15) / 0.85;
    var grd = ctx.createLinearGradient(shoot.x, shoot.y, tx, ty);
    grd.addColorStop(0, 'rgba(255,255,255,' + (0.95 * a).toFixed(3) + ')');
    grd.addColorStop(1, 'rgba(200,220,255,0)');
    ctx.strokeStyle = grd;
    ctx.lineWidth = 1.6;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(shoot.x, shoot.y);
    ctx.lineTo(tx, ty);
    ctx.stroke();
  }

  function makePollen() {
    return {
      type: 'pollen',
      x: Math.random() * cw,
      y: ch * (0.35 + Math.random() * 0.65),
      s: 0.8 + Math.random() * 1.6,
      vx: 0.05 + Math.random() * 0.15,
      vy: -0.05 - Math.random() * 0.12,
      ph: Math.random() * 6.28,
      z: 0.4 + Math.random() * 0.6
    };
  }

  function drawParticles(t, px, py, alpha) {
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cw, ch);
    if (alpha <= 0) return;
    ctx.globalAlpha = alpha;
    var gw = eggsOn ? gustWind(t) : 0;
    var wind = 0.75 + 0.45 * Math.sin(t * 0.00021) + 0.25 * Math.sin(t * 0.00063) + gw;
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      var ox = -px * 40 * p.z;
      var oy = -py * 16 * p.z;
      if (p.type === 'glint') {
        if (!glintBox) continue;
        var gl = Math.pow(Math.max(0, Math.sin(t * p.sp + p.ph)), 10);
        if (gl < 0.02) {
          if (Math.sin(t * p.sp + p.ph) < -0.98) { var ng = makeGlint(); p.u = ng.u; p.v = ng.v; }
          continue;
        }
        ctx.save();
        ctx.translate(glintBox.left + glintBox.width * p.u, glintBox.top + glintBox.height * p.v);
        ctx.scale(1, 0.45);
        ctx.beginPath();
        ctx.arc(0, 0, p.s * (0.6 + gl), 0, 6.2832);
        ctx.fillStyle = 'rgba(255,253,240,' + (0.9 * gl).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(255,250,225,0.9)';
        ctx.shadowBlur = 5;
        ctx.fill();
        ctx.restore();
        continue;
      }
      if (p.type === 'leaf') {
        p.x += p.vx + Math.sin(t * 0.0011 + p.ph) * 0.6 * p.z;
        p.y += p.vy * p.z;
        p.r += p.vr + Math.sin(t * 0.0017 + p.ph) * 0.012;
        if (p.y > ch + 30) particles[i] = makeLeaf(false);
        var lf = Math.sin(t * 0.0021 + p.ph);
        var ls = p.s * p.z;
        ctx.save();
        ctx.translate(p.x + ox, p.y + oy);
        ctx.rotate(p.r);
        ctx.scale(0.3 + Math.abs(lf) * 0.7, 1);
        ctx.beginPath();
        ctx.moveTo(0, -ls);
        ctx.quadraticCurveTo(ls * 0.75, 0, 0, ls);
        ctx.quadraticCurveTo(-ls * 0.75, 0, 0, -ls);
        ctx.fillStyle = 'rgba(' + p.c + ',' + (lf > 0 ? 0.92 : 0.75) + ')';
        ctx.fill();
        ctx.restore();
        continue;
      }
      if (p.type === 'firefly') {
        p.a += Math.sin(t * 0.0007 + p.ph) * 0.03;
        p.x += Math.cos(p.a) * p.v;
        p.y += Math.sin(p.a) * p.v * 0.6;
        if (p.x < -20) p.x = cw + 20; else if (p.x > cw + 20) p.x = -20;
        if ((p.y < ch * 0.45 && Math.sin(p.a) < 0) || (p.y > ch * 0.98 && Math.sin(p.a) > 0)) p.a = -p.a;
        var fg = Math.pow(Math.max(0, Math.sin(t * p.sp + p.ph)), 2);
        if (fg < 0.03) continue;
        ctx.beginPath();
        ctx.arc(p.x + ox, p.y + oy, p.s, 0, 6.2832);
        ctx.fillStyle = 'rgba(240,255,170,' + (0.95 * fg).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(200,255,110,0.95)';
        ctx.shadowBlur = 12;
        ctx.fill();
        ctx.shadowBlur = 0;
        continue;
      }
      if (p.type === 'dew') {
        var dw = Math.sin(t * p.sp + p.ph);
        var dg = Math.pow(Math.max(0, dw), 14);
        if (dg < 0.02) {
          if (dw < -0.98) { p.x = Math.random() * cw; p.y = ch * (0.7 + Math.random() * 0.28); }
          continue;
        }
        var ds = p.s * (0.5 + dg);
        ctx.save();
        ctx.translate(p.x + ox, p.y + oy);
        ctx.beginPath();
        ctx.moveTo(0, -ds);
        ctx.lineTo(ds * 0.18, -ds * 0.18);
        ctx.lineTo(ds, 0);
        ctx.lineTo(ds * 0.18, ds * 0.18);
        ctx.lineTo(0, ds);
        ctx.lineTo(-ds * 0.18, ds * 0.18);
        ctx.lineTo(-ds, 0);
        ctx.lineTo(-ds * 0.18, -ds * 0.18);
        ctx.closePath();
        ctx.fillStyle = 'rgba(255,255,245,' + (0.9 * dg).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(255,250,220,0.9)';
        ctx.shadowBlur = 6;
        ctx.fill();
        ctx.restore();
        ctx.shadowBlur = 0;
        continue;
      }
      if (p.type === 'star') {
        var tw = p.a * (0.55 + 0.45 * Math.sin(t * p.sp + p.ph));
        ctx.beginPath();
        ctx.arc(p.x + ox, p.y + oy, p.s, 0, 6.2832);
        ctx.fillStyle = 'rgba(255,250,240,' + tw.toFixed(3) + ')';
        ctx.fill();
        continue;
      }
      if (p.type === 'petal') {
        p.x += p.vx * wind * p.z + Math.sin(t * 0.0012 + p.ph) * 0.35;
        p.y += p.vy * p.z + Math.cos(t * 0.0009 + p.ph) * 0.12 - gw * 0.25 * p.z;
        p.r += p.vr + Math.sin(t * 0.002 + p.ph) * 0.01;
        if (p.x > cw + 30 || p.y > ch + 30) particles[i] = makePetal(false);
        var flip = Math.abs(Math.sin(t * 0.0018 + p.ph));
        ctx.save();
        ctx.translate(p.x + ox, p.y + oy);
        ctx.rotate(p.r);
        ctx.scale(1, 0.35 + flip * 0.65);
        ctx.beginPath();
        ctx.ellipse(0, 0, p.s * p.z, p.s * 0.62 * p.z, 0, 0, 6.2832);
        ctx.fillStyle = 'rgba(' + p.c + ',0.85)';
        ctx.fill();
        ctx.restore();
      } else {
        p.x += p.vx * wind + Math.sin(t * 0.0007 + p.ph) * 0.15;
        p.y += p.vy + Math.cos(t * 0.0011 + p.ph) * 0.1;
        if (p.y < ch * 0.2 || p.x > cw + 10) {
          particles[i] = makePollen();
          particles[i].y = ch + 5;
          continue;
        }
        var a = 0.35 + 0.45 * (0.5 + 0.5 * Math.sin(t * 0.003 + p.ph));
        ctx.beginPath();
        ctx.arc(p.x + ox, p.y + oy, p.s, 0, 6.2832);
        ctx.fillStyle = (p.gold ? 'rgba(255,214,140,' : 'rgba(255,248,215,') + a.toFixed(2) + ')';
        ctx.shadowColor = p.gold ? 'rgba(255,196,110,0.95)' : 'rgba(255,236,170,0.9)';
        ctx.shadowBlur = 6;
        ctx.fill();
        ctx.shadowBlur = 0;
      }
    }
    if (NIGHT) drawShootingStar(t);
    ctx.globalAlpha = 1;
    if (fx.length) drawFx(t, wind);
  }

  /* ---------- Eingaben: Maus, Neigung, Fokus ---------- */
  var target = { x: 0, y: 0 };
  var pos = { x: 0, y: 0 };
  var lastInput = -1e9;
  var formFocused = false;
  var tiltBase = null;

  window.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    target.x = (e.clientX / window.innerWidth) * 2 - 1;
    target.y = (e.clientY / window.innerHeight) * 2 - 1;
    lastInput = performance.now();
  }, { passive: true });

  window.addEventListener('deviceorientation', function (e) {
    if (e.gamma == null || e.beta == null) return;
    if (tiltBase === null) tiltBase = e.beta;
    target.x = Math.max(-1, Math.min(1, e.gamma / 22));
    target.y = Math.max(-1, Math.min(1, (e.beta - tiltBase) / 22));
    lastInput = performance.now();
  }, { passive: true });

  gate.addEventListener('focusin', function (e) {
    if (e.target.matches('input, textarea, select, button')) formFocused = true;
  });
  gate.addEventListener('focusout', function () { formFocused = false; });

  /* ---------- Easter Eggs ----------
     1 Kaschmirziegen: antippen, die Ziege hüpft und feiner Kaschmirflaum schwebt davon
     2 Gebetsfahnen: folgen dem Mauszeiger, ein Klick schickt einen Windstoß mit Segenslichtern durchs Tal
     3 Stupa: ein Klick schlägt eine Klangschale an, goldene Klangwellen laufen durchs Tal
     4 Schmetterling: wer die Maus ruhig hält, bekommt Besuch
     Aktiv erst nach dem Auftritt des Schilds. Über den Objekten zeigt der Zeiger, was passiert. */
  // Nur am Desktop mit Maus: auf dem Handy würde das eher verunsichern
  var eggsOn = !reduceMotion && !!ctx && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var fx = [];
  var flagData = [];
  var flagRect = null;
  var flagsMoving = false;
  var gust = { t0: -1e9, s: 1, timer: 0 };
  var hover = null;
  var lastEggAt = -1e9;
  var lastLeave = -1e9;
  var lastBowl = -1e9;
  var nextHint = 0;
  var noteEl = null;
  var flagNoteShown = false;
  var goatNote = 0;
  var audio = null;
  var boardRect = null;
  var ptr = { x: -1e4, y: -1e4, fx: null, fy: null, vx: 0, vy: 0, inside: false, mouse: true, moved: -1e9, target: null };
  var goatEls = Array.prototype.slice.call(scene.querySelectorAll('.sg-goat'));
  var stupaEl = scene.querySelector('.sg-hot--stupa');
  var boardEl = gate.querySelector('.sg-board');
  var fxLayer = null;
  var INK = '#3a2f26';
  var CURSOR = {};
  var GOAT_NOTES = [
    'Die Fasern aus einem einzigen Gramm Kaschmir ergeben aneinandergelegt rund vier Kilometer.',
    'Im Frühjahr wird das weiche Unterfell von Hand ausgekämmt.',
    'Eine Ziege schenkt uns rund 150 Gramm Kaschmir im Jahr.',
    'Für einen Pullover braucht es das Unterfell von drei bis vier Ziegen.'
  ];

  // Zeiger: heller Kreis mit Goldrand und einem Symbol, scharf auch auf Retina-Bildschirmen
  function cursorFor(icon) {
    function svg(size) {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 36 36">' +
        '<circle cx="18" cy="18" r="15.6" fill="#fbf7ee" fill-opacity=".96" stroke="#b8913e" stroke-width="1.6"/>' + icon + '</svg>';
    }
    var u1 = 'url("data:image/svg+xml,' + encodeURIComponent(svg(36)) + '")';
    var u2 = 'url("data:image/svg+xml,' + encodeURIComponent(svg(72)) + '")';
    var tries = [
      'image-set(' + u1 + ' 1x, ' + u2 + ' 2x) 18 18, pointer',
      '-webkit-image-set(' + u1 + ' 1x, ' + u2 + ' 2x) 18 18, pointer',
      u1 + ' 18 18, pointer'
    ];
    var probe = document.createElement('div').style;
    for (var i = 0; i < tries.length; i++) {
      probe.cursor = tries[i];
      if (probe.cursor) return tries[i];
    }
    return 'pointer';
  }

  if (eggsOn) {
    fxLayer = document.createElement('div');
    fxLayer.className = 'sg-fx';
    fxLayer.setAttribute('aria-hidden', 'true');
    gate.appendChild(fxLayer);

    CURSOR = {
      // Herz: Ziegen streicheln
      goat: cursorFor('<path d="M18 26.2c-.5-.3-8.2-5-8.2-10.6 0-2.7 2-4.7 4.5-4.7 1.6 0 3 .8 3.7 2.2.7-1.4 2.1-2.2 3.7-2.2 2.5 0 4.5 2 4.5 4.7 0 5.6-7.7 10.3-8.2 10.6z" fill="#b5523e"/>'),
      // Noten: hier erklingt etwas
      stupa: cursorFor('<path d="M15.2 23.4V12.9l9.2-2.1v10.4" fill="none" stroke="' + INK + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><ellipse cx="13" cy="23.5" rx="2.6" ry="2" transform="rotate(-18 13 23.5)" fill="' + INK + '"/><ellipse cx="22.2" cy="21.2" rx="2.6" ry="2" transform="rotate(-18 22.2 21.2)" fill="' + INK + '"/>'),
      // Wind: Fahnen anpusten
      flags: cursorFor('<path d="M9.8 15h10.4a2.7 2.7 0 1 0-2.7-2.7M9.8 19h15a2.7 2.7 0 1 1-2.7 2.7M9.8 23h7" fill="none" stroke="' + INK + '" stroke-width="1.8" stroke-linecap="round"/>')
    };

    gate.addEventListener('pointermove', function (e) {
      ptr.mouse = e.pointerType === 'mouse';
      if (Math.abs(e.clientX - ptr.x) + Math.abs(e.clientY - ptr.y) > 2) ptr.moved = performance.now();
      ptr.x = e.clientX;
      ptr.y = e.clientY;
      ptr.inside = true;
      ptr.target = e.target;
    }, { passive: true });
    gate.addEventListener('pointerleave', function () { ptr.inside = false; });
    gate.addEventListener('click', function (e) {
      if (!eggsReady() || isUi(e.target)) return;
      var h = hitAt(e.clientX, e.clientY);
      if (h) runEgg(h, e.clientX, e.clientY);
    });
  }

  function eggsReady() {
    return eggsOn && gate.classList.contains('sg-intro-done');
  }

  function isUi(el) {
    return !!(el && el.closest && el.closest('.sg-board, .sg-legal, .sg-arrow, a, button, input, textarea, select, label'));
  }

  // Welches Objekt liegt unter dem Zeiger? Vordere Ziegen zuerst, kleine Ziegen bekommen eine größere Trefferfläche
  function hitAt(x, y) {
    if (!eggsReady()) return null;
    for (var i = goatEls.length - 1; i >= 0; i--) {
      var r = goatEls[i].getBoundingClientRect();
      if (!r.width) continue;
      var rx = Math.max(24, r.width * 0.55);
      var ry = Math.max(24, r.height * 0.55);
      var dx = (x - r.left - r.width / 2) / rx;
      var dy = (y - r.top - r.height / 2) / ry;
      if (dx * dx + dy * dy <= 1) return { type: 'goat', el: goatEls[i] };
    }
    if (stupaEl) {
      var s = stupaEl.getBoundingClientRect();
      if (s.width && x >= s.left && x <= s.right && y >= s.top && y <= s.bottom) return { type: 'stupa', el: stupaEl };
    }
    if (flagRect) {
      for (var f = 0; f < flagData.length; f++) {
        var fdx = x - flagRect.left - flagData[f].sx;
        var fdy = y - flagRect.top - flagData[f].sy;
        if (fdx * fdx + fdy * fdy < 256) return { type: 'flags', el: null };
      }
    }
    return null;
  }

  function setHover(h) {
    if (h && hover && h.type === hover.type && h.el === hover.el) return;
    if (!h && !hover) return;
    if (hover && hover.el) hover.el.classList.remove('is-hover');
    hover = h;
    if (h && h.el) h.el.classList.add('is-hover');
    gate.style.cursor = h ? CURSOR[h.type] || 'pointer' : '';
  }

  function readEggs(t) {
    flagRect = flagsSvg && flagData.length ? flagsSvg.getBoundingClientRect() : null;
    boardRect = boardEl ? boardEl.getBoundingClientRect() : null;
    if (ptr.fx === null) { ptr.fx = ptr.x; ptr.fy = ptr.y; }
    ptr.vx = ptr.x - ptr.fx;
    ptr.vy = ptr.y - ptr.fy;
    ptr.fx = ptr.x;
    ptr.fy = ptr.y;
    if (ptr.inside && ptr.mouse && eggsReady()) setHover(isUi(ptr.target) ? null : hitAt(ptr.x, ptr.y));
    else if (hover) setHover(null);
    butterflyRest(t);
    hintSparkle(t);
  }

  function runEgg(h, x, y) {
    lastEggAt = performance.now();
    if (h.type === 'goat') pokeGoat(h.el);
    else if (h.type === 'stupa') ringBowl(h.el);
    else windGust(x, y, 1, false);
  }

  function showNote(text, x, y) {
    if (noteEl && noteEl.parentNode) noteEl.parentNode.removeChild(noteEl);
    var n = document.createElement('div');
    n.className = 'sg-note';
    n.textContent = text;
    fxLayer.appendChild(n);
    var w = n.offsetWidth;
    var h = n.offsetHeight;
    var vw = document.documentElement.clientWidth;
    n.style.left = Math.max(16 + w / 2, Math.min(vw - 16 - w / 2, x)) + 'px';
    n.style.top = Math.max(h + 12, y) + 'px';
    noteEl = n;
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 4700);
  }

  /* 1 Kaschmirziegen */
  function pokeGoat(el) {
    var body = el.querySelector('.sg-goat__body') || el;
    body.classList.remove('is-poked');
    void body.offsetWidth;
    body.classList.add('is-poked');
    if (el.classList.contains('sg-goat--graze')) {
      el.classList.add('is-looking');
      clearTimeout(el.sgLook);
      el.sgLook = setTimeout(function () { el.classList.remove('is-looking'); }, 2600);
    }
    var r = el.getBoundingClientRect();
    spawnFluff(r.left + r.width / 2, r.top + r.height * 0.4, Math.max(18, r.width));
    var kid = el.classList.contains('sg-goat--kid');
    showNote(kid ? 'Mäh!' : GOAT_NOTES[goatNote++ % GOAT_NOTES.length], r.left + r.width / 2, r.top - 10);
  }

  function spawnFluff(x, y, size) {
    var t = performance.now();
    for (var i = 0; i < 6; i++) {
      var strands = [];
      var m = 10 + Math.floor(Math.random() * 6);
      for (var k = 0; k < m; k++) strands.push([Math.random() * 6.283, 3 + Math.random() * 7, (Math.random() - 0.5) * 0.9]);
      fx.push({
        type: 'fluff',
        x: x + (Math.random() - 0.5) * size * 0.7,
        y: y + (Math.random() - 0.5) * size * 0.25,
        vx: 0.1 + Math.random() * 0.5,
        vy: -0.3 - Math.random() * 0.5,
        r: Math.random() * 6.283,
        vr: (Math.random() - 0.5) * 0.02,
        s: 0.75 + Math.random() * 0.6,
        st: strands,
        t0: t + i * 60,
        life: 5600 + Math.random() * 2400,
        ph: Math.random() * 6.283
      });
    }
  }

  /* 2 Gebetsfahnen */
  function lighten(hex) {
    var n = parseInt(hex.replace('#', ''), 16);
    var r = (n >> 16) & 255;
    var g = (n >> 8) & 255;
    var b = n & 255;
    return Math.round(r + (255 - r) * 0.55) + ',' + Math.round(g + (255 - g) * 0.55) + ',' + Math.round(b + (255 - b) * 0.45);
  }

  function windGust(x, y, strength, quiet) {
    var t = performance.now();
    // ein laufender Windstoß wird nur von einem stärkeren abgelöst (der Klick auf die Fahnen schlägt den leisen Nachwind der Klangschale)
    if (t - gust.t0 < 1400 && strength <= gust.s) return;
    gust.t0 = t;
    gust.s = strength;
    if (strength >= 1) {
      gate.classList.remove('sg-gust');
      void gate.offsetWidth;
      gate.classList.add('sg-gust');
      clearTimeout(gust.timer);
      gust.timer = setTimeout(function () { gate.classList.remove('sg-gust'); }, 3200);
    }
    if (!flagRect) return;
    var vw = window.innerWidth;
    for (var i = 0; i < flagData.length; i += strength >= 1 ? 2 : 5) {
      var F = flagData[i];
      var sx = flagRect.left + F.sx;
      var sy = flagRect.top + F.sy;
      if (sx < -20 || sx > vw + 20) continue;
      fx.push({
        type: 'mote',
        x: sx,
        y: sy,
        vx: (1.4 + Math.random() * 2.2) * strength,
        vy: -0.3 - Math.random() * 1.1,
        t0: t + (sx / vw) * 450,
        life: 3200 + Math.random() * 1800,
        s: 1 + Math.random() * 1.3,
        ph: Math.random() * 6.283,
        c: lighten(F.c)
      });
    }
    if (!quiet && !flagNoteShown) {
      flagNoteShown = true;
      showNote('Der Wind trägt die guten Wünsche der Gebetsfahnen in die Welt.', x, y + 76);
    }
  }

  function gustWind(t) {
    var g = (t - gust.t0) / 1000;
    if (g < 0 || g > 3.6) return 0;
    return 5 * gust.s * (g < 0.3 ? g / 0.3 : Math.exp(-(g - 0.3) * 1.3));
  }

  // Jede Fahne ist ein gedämpftes Pendel: Mausbewegung in der Nähe und Windstöße schubsen sie an
  function updateFlags(t) {
    if (!flagRect || !flagData.length) return;
    var gt = (t - gust.t0) / 1000;
    var gustOn = gt >= 0 && gt < 4;
    var push = ptr.inside && ptr.mouse && Math.abs(ptr.vx) + Math.abs(ptr.vy) > 0.5;
    if (!gustOn && !push && !flagsMoving) return;
    flagsMoving = false;
    var vw = window.innerWidth;
    var pvx = Math.max(-16, Math.min(16, ptr.vx));
    for (var i = 0; i < flagData.length; i++) {
      var F = flagData[i];
      var sx = flagRect.left + F.sx;
      var force = 0;
      if (push) {
        var d = Math.hypot(ptr.x - sx, ptr.y - flagRect.top - F.sy);
        if (d < 120) force -= pvx * 0.22 * (1 - d / 120);
      }
      if (gustOn) {
        var lg = gt - (sx / vw) * 0.45;
        if (lg > 0 && lg < 3.4) force -= gust.s * (lg < 0.25 ? lg / 0.25 : Math.exp(-(lg - 0.25) * 1.25)) * (0.9 + 0.7 * Math.sin(lg * 12 + F.i * 0.8));
      }
      F.v = (F.v + force - F.a * 0.05) * 0.93;
      F.a = Math.max(-55, Math.min(55, F.a + F.v));
      if (Math.abs(F.a) > 0.08 || Math.abs(F.v) > 0.08) {
        flagsMoving = true;
        F.moved = true;
        F.g.setAttribute('transform', F.base + ' rotate(' + F.a.toFixed(2) + ')');
      } else if (F.moved) {
        F.a = 0;
        F.v = 0;
        F.moved = false;
        F.g.setAttribute('transform', F.base);
      }
    }
  }

  /* 3 Stupa mit Klangschale */
  function ringBowl(el) {
    var t = performance.now();
    if (t - lastBowl < 1200) return;
    lastBowl = t;
    playBowl();
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.bottom - r.height * 0.08;
    var maxR = Math.max(window.innerWidth, 800) * 0.62;
    for (var i = 0; i < 3; i++) fx.push({ type: 'ring', x: cx, y: cy, t0: t + i * 450, life: 4200, r: maxR });
    fx.push({ type: 'bloom', x: cx, y: r.top + r.height * 0.4, t0: t, life: 2800, s: Math.max(46, r.width * 1.1) });
    el.classList.remove('is-ringing');
    void el.offsetWidth;
    el.classList.add('is-ringing');
    // die Klangwelle erreicht die Fahnen und lässt sie leise wehen
    setTimeout(function () { windGust(0, 0, 0.35, true); }, 1000);
  }

  // Klangschale, im Browser erzeugt: leicht verstimmte Teiltöne schweben gegeneinander, dazu etwas Raumhall
  function playBowl() {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    try {
      if (!audio) {
        var a = new AC();
        var comp = a.createDynamicsCompressor();
        comp.connect(a.destination);
        var rev = a.createConvolver();
        var len = Math.round(a.sampleRate * 3.5);
        var ir = a.createBuffer(2, len, a.sampleRate);
        for (var ch = 0; ch < 2; ch++) {
          var data = ir.getChannelData(ch);
          for (var s = 0; s < len; s++) data[s] = (Math.random() * 2 - 1) * Math.pow(1 - s / len, 3);
        }
        rev.buffer = ir;
        var wet = a.createGain();
        wet.gain.value = 0.28;
        rev.connect(wet);
        wet.connect(comp);
        audio = { ac: a, out: comp, rev: rev };
      }
      var ac = audio.ac;
      if (ac.state === 'suspended') ac.resume();
      var t0 = ac.currentTime + 0.02;
      var bus = ac.createGain();
      bus.gain.value = 0.12;
      bus.connect(audio.out);
      bus.connect(audio.rev);
      var f = 196 * (0.97 + Math.random() * 0.06);
      [[1, 1, 12], [2.72, 0.5, 8], [5.12, 0.26, 5], [8.3, 0.12, 3], [12.2, 0.05, 1.6]].forEach(function (p, i) {
        [-1, 1].forEach(function (side) {
          var o = ac.createOscillator();
          var g = ac.createGain();
          o.frequency.value = f * p[0] + side * (0.35 + i * 0.45);
          g.gain.setValueAtTime(0.0001, t0);
          g.gain.exponentialRampToValueAtTime(p[1] * 0.5, t0 + 0.015);
          g.gain.exponentialRampToValueAtTime(0.0001, t0 + p[2]);
          o.connect(g);
          g.connect(bus);
          o.start(t0);
          o.stop(t0 + p[2] + 0.05);
        });
      });
      // weicher Anschlag des Klöppels
      var nb = ac.createBuffer(1, Math.round(ac.sampleRate * 0.06), ac.sampleRate);
      var nd = nb.getChannelData(0);
      for (var k = 0; k < nd.length; k++) nd[k] = (Math.random() * 2 - 1) * Math.pow(1 - k / nd.length, 5);
      var src = ac.createBufferSource();
      var bp = ac.createBiquadFilter();
      var ng = ac.createGain();
      src.buffer = nb;
      bp.type = 'bandpass';
      bp.frequency.value = 1100;
      bp.Q.value = 1.4;
      ng.gain.value = 0.35;
      src.connect(bp);
      bp.connect(ng);
      ng.connect(bus);
      src.start(t0);
    } catch (e) { /* ohne Ton geht es auch */ }
  }

  /* 4 Schmetterling */
  function butterflyRest(t) {
    if (!butterflies.length || !eggsReady()) return;
    for (var i = 0; i < butterflies.length; i++) {
      var B = butterflies[i];
      if (B.mode === 'approach' || B.mode === 'landed') {
        // die Maus bewegt sich: er fliegt davon
        if (B.follow && (!ptr.inside || t - ptr.moved < 80)) leaveButterfly(B, t);
        return;
      }
    }
    if (ptr.mouse && ptr.inside && t - ptr.moved > 1500 && t - lastLeave > 2500) callButterfly(ptr.x, ptr.y, 0, true);
  }

  function callButterfly(x, y, ms, follow) {
    if (!butterflies.length || !fxLayer) return;
    var best = null;
    var bd = 1e9;
    for (var i = 0; i < butterflies.length; i++) {
      var B = butterflies[i];
      if (B.mode === 'landed') continue;
      var d = Math.hypot(B.x - x, B.y - y);
      if (d < bd) { bd = d; best = B; }
    }
    if (!best) return;
    best.mode = 'approach';
    best.follow = follow;
    best.tx = x - 13;
    best.ty = y - 17;
    best.until = follow ? 0 : performance.now() + ms;
    // fliegt vor das Schild, damit er auch über der Tafel zu sehen ist
    if (best.el.parentNode !== fxLayer) fxLayer.appendChild(best.el);
  }

  function leaveButterfly(B, t) {
    B.mode = 'leave';
    B.t0 = t;
    B.follow = false;
    B.until = 0;
    lastLeave = t;
    B.el.classList.remove('is-landed');
    var ang = -Math.PI / 2 + (Math.random() - 0.5) * 1.8;
    B.vx = Math.cos(ang) * 5;
    B.vy = Math.sin(ang) * 5;
  }

  function moveButterfly(B, t, W, H) {
    var wx = W * (B.cx + B.ax * Math.sin(t * 0.001 * B.f1 * 6 + B.p1) + 0.05 * Math.sin(t * 0.001 * B.f2 * 9 + B.p2)) - pos.x * 50;
    var wy = H * (B.cy + B.ay * Math.sin(t * 0.001 * B.f2 * 5 + B.p2) + 0.03 * Math.sin(t * 0.001 * B.f1 * 13 + B.p1)) - pos.y * 20;
    var sc = 1;
    if (B.mode === 'approach' || B.mode === 'landed') {
      if (B.follow) { B.tx = ptr.x - 13; B.ty = ptr.y - 17; }
      var ddx = B.tx - B.x;
      var ddy = B.ty - B.y;
      if (B.mode === 'approach') {
        var wob = Math.min(1, Math.hypot(ddx, ddy) / 90);
        B.x += ddx * 0.055 + Math.sin(t * 0.011 + B.p1) * 2.4 * wob;
        B.y += ddy * 0.055 + Math.cos(t * 0.017 + B.p2) * 1.8 * wob;
        if (Math.hypot(ddx, ddy) < 2) { B.mode = 'landed'; B.el.classList.add('is-landed'); }
      } else {
        B.x = B.tx;
        B.y = B.ty;
      }
      if (B.until && t > B.until) leaveButterfly(B, t);
      sc = 1.35;
    } else if (B.mode === 'leave') {
      var k = Math.min(1, (t - B.t0) / 1800);
      B.vx *= 0.96;
      B.vy *= 0.96;
      B.x += B.vx + (wx - B.x) * (0.02 + 0.18 * k);
      B.y += B.vy + (wy - B.y) * (0.02 + 0.18 * k);
      sc = 1.35 - 0.35 * k;
      var overBoard = boardRect && B.x + 13 > boardRect.left && B.x + 13 < boardRect.right && B.y + 10 > boardRect.top && B.y + 10 < boardRect.bottom;
      if (k >= 1 && !overBoard && Math.abs(wx - B.x) + Math.abs(wy - B.y) < 8) {
        B.mode = 'wander';
        if (B.el.parentNode !== scene) scene.insertBefore(B.el, B.ref);
      }
    } else {
      B.x = wx;
      B.y = wy;
    }
    var dx = B.x - B.lx;
    var dy = B.y - B.ly;
    B.lx = B.x;
    B.ly = B.y;
    B.sc += (sc - B.sc) * 0.08;
    var landed = B.mode === 'landed';
    if (!landed && Math.abs(dx) > 0.3) B.dir = dx < 0 ? -1 : 1;
    var tilt = landed ? -8 : Math.max(-35, Math.min(35, dx * 6));
    var y = B.y + (B.mode === 'wander' ? dy : 0);
    B.el.style.transform = 'translate3d(' + B.x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + tilt.toFixed(1) + 'deg) scale(' + (B.sc * B.dir).toFixed(3) + ',' + B.sc.toFixed(3) + ')';
  }

  // Ab und zu funkelt es kurz an einer Ziege oder am Stupa: ein leiser Hinweis, dass man dort etwas entdecken kann
  function hintSparkle(t) {
    if (!eggsReady()) { nextHint = t + 5000; return; }
    if (t < nextHint) return;
    nextHint = t + 7000 + Math.random() * 6000;
    if (hover || t - lastEggAt < 9000) return;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var cands = [];
    goatEls.concat(stupaEl ? [stupaEl] : []).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.right < 0 || r.left > vw || r.bottom < 0 || r.top > vh) return;
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height * 0.3;
      if (boardRect && cx > boardRect.left && cx < boardRect.right && cy > boardRect.top && cy < boardRect.bottom) return;
      cands.push([cx, cy, r.width]);
    });
    if (!cands.length) return;
    var c = cands[Math.floor(Math.random() * cands.length)];
    fx.push({ type: 'spark', x: c[0] + (Math.random() - 0.5) * c[2] * 0.4, y: c[1], t0: t, life: 1400, s: 5 + Math.random() * 3 });
  }

  // Effekte der Easter Eggs, gezeichnet auf der Partikel-Leinwand hinter dem Schild
  function drawFx(t, wind) {
    for (var i = fx.length - 1; i >= 0; i--) {
      var f = fx[i];
      if (t < f.t0) continue;
      var k = (t - f.t0) / f.life;
      if (k >= 1) { fx.splice(i, 1); continue; }
      if (f.type === 'fluff') {
        f.x += f.vx * (0.5 + wind * 0.5) + Math.sin(t * 0.0013 + f.ph) * 0.3;
        f.y += f.vy;
        f.vy *= 0.996;
        f.r += f.vr;
        var fa = k < 0.1 ? k / 0.1 : Math.pow(1 - (k - 0.1) / 0.9, 1.3);
        var gs = f.s * (1 + k * 0.7);
        ctx.save();
        ctx.translate(f.x, f.y);
        ctx.rotate(f.r);
        ctx.beginPath();
        for (var j = 0; j < f.st.length; j++) {
          var st = f.st[j];
          var ex = Math.cos(st[0]) * st[1] * gs;
          var ey = Math.sin(st[0]) * st[1] * gs;
          ctx.moveTo(0, 0);
          ctx.quadraticCurveTo(ex * 0.5 - ey * st[2], ey * 0.5 + ex * st[2], ex, ey);
        }
        ctx.shadowBlur = 0;
        ctx.lineCap = 'round';
        ctx.lineWidth = 1.8;
        ctx.strokeStyle = 'rgba(120,100,80,' + (0.1 * fa).toFixed(3) + ')';
        ctx.stroke();
        ctx.lineWidth = 0.8;
        ctx.strokeStyle = 'rgba(' + FLUFF + ',' + (0.85 * fa).toFixed(3) + ')';
        ctx.stroke();
        ctx.restore();
      } else if (f.type === 'mote') {
        f.x += f.vx;
        f.y += f.vy + Math.sin(t * 0.004 + f.ph) * 0.45;
        f.vx *= 0.993;
        f.vy -= 0.003;
        var ma = (k < 0.08 ? k / 0.08 : 1 - (k - 0.08) / 0.92) * (0.65 + 0.35 * Math.sin(t * 0.013 + f.ph));
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.s, 0, 6.2832);
        ctx.fillStyle = 'rgba(' + f.c + ',' + ma.toFixed(3) + ')';
        ctx.shadowColor = 'rgba(255,236,180,0.95)';
        ctx.shadowBlur = 9;
        ctx.fill();
      } else if (f.type === 'ring') {
        var rr = f.r * (1 - Math.pow(1 - k, 3));
        ctx.save();
        ctx.translate(f.x, f.y);
        ctx.scale(1, 0.3);
        ctx.beginPath();
        ctx.arc(0, 0, Math.max(1, rr), 0, 6.2832);
        ctx.restore();
        ctx.lineWidth = 0.6 + 2.2 * (1 - k);
        ctx.strokeStyle = 'rgba(255,230,165,' + (0.6 * Math.pow(1 - k, 1.6)).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(255,220,140,0.9)';
        ctx.shadowBlur = 12;
        ctx.stroke();
      } else if (f.type === 'bloom') {
        var ba = k < 0.2 ? k / 0.2 : 1 - (k - 0.2) / 0.8;
        var br = f.s * (1 + k * 0.5);
        var grd = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, br);
        grd.addColorStop(0, 'rgba(255,244,210,' + (0.75 * ba).toFixed(3) + ')');
        grd.addColorStop(1, 'rgba(255,244,210,0)');
        ctx.shadowBlur = 0;
        ctx.fillStyle = grd;
        ctx.beginPath();
        ctx.arc(f.x, f.y, br, 0, 6.2832);
        ctx.fill();
      } else if (f.type === 'spark') {
        var sa = Math.sin(k * Math.PI);
        var ss = f.s * (0.4 + 0.6 * sa);
        ctx.save();
        ctx.translate(f.x, f.y);
        ctx.rotate(k * 0.6);
        ctx.beginPath();
        ctx.moveTo(0, -ss);
        ctx.lineTo(ss * 0.18, -ss * 0.18);
        ctx.lineTo(ss, 0);
        ctx.lineTo(ss * 0.18, ss * 0.18);
        ctx.lineTo(0, ss);
        ctx.lineTo(-ss * 0.18, ss * 0.18);
        ctx.lineTo(-ss, 0);
        ctx.lineTo(-ss * 0.18, -ss * 0.18);
        ctx.closePath();
        ctx.fillStyle = 'rgba(255,252,238,' + (0.95 * sa).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(255,236,170,0.95)';
        ctx.shadowBlur = 10;
        ctx.fill();
        ctx.restore();
      }
    }
    ctx.shadowBlur = 0;
  }

  /* ---------- Hauptschleife ---------- */
  var MAX_X = 90;
  var MAX_Y = 34;
  var running = false;

  function frame(now) {
    if (!running) return;
    requestAnimationFrame(frame);
    if (!gate.getClientRects().length) return;

    var t = now;
    if (glintEl) glintBox = glintEl.getBoundingClientRect();
    // Easter Eggs: erst alles messen, danach wird geschrieben (kein erzwungenes Layout)
    if (eggsOn) readEggs(now);
    var idle = now - lastInput > 2500;
    var tx = idle ? Math.sin(t * 0.00013) * 0.45 : target.x;
    var ty = idle ? Math.sin(t * 0.00009 + 1) * 0.2 : target.y;
    if (formFocused) { tx *= 0.15; ty *= 0.15; }
    pos.x += (tx - pos.x) * 0.045;
    pos.y += (ty - pos.y) * 0.045;

    // Kamera: Fortschritt e (0 = am Berg, 1 = Ruheposition)
    var e = 1;
    if (freeze !== null) e = freeze;
    else if (!camera.done && camera.start !== null) {
      var x = Math.min(1, (now - camera.start) / camera.duration);
      if (camera.skipAt !== null) {
        x = camera.xAtSkip + (1 - camera.xAtSkip) * Math.min(1, (now - camera.skipAt) / 900);
      }
      e = easeInOutCubic(x);
      // Schild, Pfosten und Fahnen, sobald die Kamera sichtbar steht (im letzten Zehntel bewegt sie sich unter 1 %)
      if (x >= 0.9) showSign();
      if (x >= 1) {
        camera.done = true;
        gate.classList.remove('sg-flying');
        endFlight();
      }
    } else if (!camera.done) e = 1; // vor dem Start: Ruhelage, damit Chrome die Szene in normaler Größe rastert
    var c = camera.done && freeze === null ? 0 : cameraAt(e);
    // Handy: m = wie weit die Kamera noch vorn ist (1 = Start, 0 = Ruhelage), keine Ebene hinter der Kamera
    var m = 0;
    if (MOBILE) { m = c > 0 ? 1 - e : 0; c = 0; }

    for (var i = 0; i < layers.length; i++) {
      var L = layers[i];
      var d = L.depth;
      var x = -pos.x * d * MAX_X;
      var y = -pos.y * d * MAX_Y;
      var s = 1;
      var o = 1;
      if (m > 0 && L.z !== null) s = 1 + (L.mz - 1) * m;
      else if (L.z !== null && c > 0) {
        var gap = L.z - c;
        if (gap <= 0.02) { s = SMAX; o = 0; }
        else {
          s = L.z / gap;
          o = Math.max(0, Math.min(1, (SMAX - s) / (SMAX - 2.1)));
          if (s > SMAX) s = SMAX;
        }
      }
      if (cf && L.cf) {
        // Diese Ebene fliegt auf der Leinwand, das echte Element bleibt in Ruhelage (nur Parallaxe)
        L.fx.x = x; L.fx.y = y; L.fx.s = s; L.fx.o = o;
        s = 1;
        o = 1;
      }
      L.el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
      // Nie ganz 0: Eine Ebene mit Deckkraft 0 zeichnet Chrome nicht und verwirft ihre Rasterung. Blendet sie
      // mitten in der Fahrt wieder ein, rastert Chrome sie bei bis zu 4,2-facher Größe neu und es flackert.
      L.el.style.opacity = o >= 1 ? '' : Math.max(o, 0.002).toFixed(3);
    }
    if (cf) drawFlight();

    var W = window.innerWidth;
    var H = window.innerHeight;
    for (var b = 0; b < butterflies.length; b++) moveButterfly(butterflies[b], t, W, H);
    if (eggsOn) updateFlags(now);

    drawParticles(t, pos.x, pos.y, MOBILE ? Math.max(0, Math.min(1, 1 - m / 0.35)) : (c > 0.6 ? 0 : 1 - c / 0.6));
  }

  function start() {
    if (running || reduceMotion) return;
    running = true;
    requestAnimationFrame(frame);
  }

  function stop() { running = false; }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { sizeFlight(); measureOrigins(); sizeCanvas(); drawFlags(); }, 150);
  });

  /* ---------- Nach dem Absenden: Rückmeldung mittig zeigen ---------- */
  // Shopify lädt nach dem Absenden neu und springt per #anker zum Formular. Weil die Tafel
  // in einer eigenen Scroll-Fläche liegt, landet dieser Sprung falsch. Wir korrigieren das.
  function showFormResult() {
    var result = gate.querySelector('.sg-board .banner');
    if (!result && !posted) return;
    var targetEl = result || gate.querySelector('.sg-board');
    window.scrollTo(0, 0);
    var gateRect = gate.getBoundingClientRect();
    var targetRect = targetEl.getBoundingClientRect();
    gate.scrollTop += targetRect.top - gateRect.top - Math.max(0, (gate.clientHeight - targetRect.height) / 2);
    if (location.hash && window.history.replaceState) {
      window.history.replaceState(null, '', location.pathname + location.search);
    }
  }

  window.addEventListener('load', function () { setTimeout(showFormResult, 30); });

  function onReady() {
    measureOrigins();
    var ph = gate.querySelector('.sg-placeholder');
    if (ph) setTimeout(function () { ph.parentNode && ph.parentNode.removeChild(ph); }, 2500);
    if (!willFly()) { startIntro(); return; }
    setupFlight();
    // Chrome friert bei will-change: transform die Auflösung der ersten Rasterung ein. Würde eine Ebene
    // erst mitten in der Fahrt (bis 4,2-fach vergrößert, auf Retina 8,4-fach) gerastert, blieben riesige
    // Bitmaps im Grafikspeicher, Kacheln fielen weg und es flackerte. Darum rastert Chrome die Szene zuerst
    // unsichtbar in Ruhelage (Deckkraft 0,002 bis .sg-go, siehe CSS), erst danach startet die Fahrt.
    var t0 = performance.now();
    var frames = 0;
    (function wait() {
      if (performance.now() - t0 < 200 || ++frames < 6) { requestAnimationFrame(wait); return; }
      startIntro();
    })();
  }

  function init() {
    showFormResult();
    // Animationen in den Flug-Ebenen sofort einfrieren, damit sie in Ruhelage mitgerastert werden
    if (willFly()) gate.classList.add('sg-flying');
    sizeCanvas();
    drawFlags();
    measureOrigins();
    if (gate.classList.contains('sg-ready')) onReady();
    else gate.addEventListener('sg:ready', onReady, { once: true });
    if (reduceMotion) {
      drawParticles(0, 0, 0, 1);
      return;
    }
    start();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  } else {
    init();
  }

  /* Theme-Editor: Szene neu vermessen, wenn die Section angezeigt wird */
  document.addEventListener('shopify:section:select', function () {
    setTimeout(function () { measureOrigins(); sizeCanvas(); drawFlags(); showSign(); }, 50);
  });
})();
